/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The scope of the equipment browser view
 */
export const Scope = {
  Facility: "facility",
  Organization: "organization",
  Personal: "personal",
} as const;
/**
 * The scope of the equipment browser view
 */
export type Scope = OpenEnum<typeof Scope>;

export type EquipmentBrowserViewMeta = {
  /**
   * The description of the equipment browser view
   */
  description?: string | undefined;
  /**
   * Universally unique identifier
   */
  id: string;
  /**
   * The name of the equipment browser view
   */
  name: string;
  /**
   * The scope of the equipment browser view
   */
  scope: Scope;
};

/** @internal */
export const Scope$inboundSchema: z.ZodType<Scope, z.ZodTypeDef, unknown> =
  openEnums.inboundSchema(Scope);

/** @internal */
export const EquipmentBrowserViewMeta$inboundSchema: z.ZodType<
  EquipmentBrowserViewMeta,
  z.ZodTypeDef,
  unknown
> = z.object({
  description: types.optional(types.string()),
  id: types.string(),
  name: types.string(),
  scope: Scope$inboundSchema,
});

export function equipmentBrowserViewMetaFromJSON(
  jsonString: string,
): SafeParseResult<EquipmentBrowserViewMeta, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EquipmentBrowserViewMeta$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EquipmentBrowserViewMeta' from JSON`,
  );
}
